module.exports = __webpack_public_path__ + "img/20200510_123157.a56f3880.jpg";